<template>
  <div class="child-wrapper">
    <slot></slot>
    <div v-if="!isPreview && isEditMode" class="mask">
      <i v-if="showSortIcon" class="el-icon-sort draggable-handle"></i>
      <el-button class="edit-btn" @click="onEditChildBtnClik">{{ $t('microSite.editor.common.editComponent') }}</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    showSortIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters('microSite', ['isEditMode', 'isPreview', 'currentPage'])
  },
  created () {

  },
  methods: {
    onEditChildBtnClik () {
      if (this.isPreview || !this.isEditMode) {
        return
      }
      this.$emit('openChildEditor')
    }
  }
}
</script>

<style lang="scss" scoped>
.child-wrapper {
  position: relative;

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 90;

    .draggable-handle {
      display: none;
      top: 6px;
      right: 150px;
      color: #333;
      font-size: 24px;
      position: absolute;
    }

    .edit-btn {
      display: none;
      width: 95px;
      padding: 8px 20px;
      height: 32px;
      color: #fff;
      background-color: #008dc2;
      position: absolute;
      top: 2px;
      right: 20px;
    }

    &:hover {
      border: 1px solid #dddfe3;
      background-color: rgba(244,244,246,0.5);
      opacity: 1;

      .edit-btn {
        display: block;
      }

      .draggable-handle {
        display: block;
      }
    }
  }
}
</style>
